const Blogpost = () =>{
    return(
        <>
        <div className="px-4 py-5">
  <div className="relative flex flex-wrap justify-center">
    <div className="w-full">
      <div className="py-12">
       
        <div className="flex flex-wrap justify-center mb-12">
          <div className="w-full lg:w-8/12 px-4 text-center">
            <h6 className="mb-2 font-bold uppercase text-emerald-500">Our latest blogposts</h6>
            <h3 className="mt-3 mb-1 text-3xl font-bold text-gray-800">Check the news for this month</h3>
            <p className="mt-2 mb-4 text-xl leading-relaxed text-gray-500">
              I always felt like I could do anything. That’s the main thing people are controlled by! Thoughts — their perception of themselves!
            </p>
          </div>
        </div>

     
        <div className="flex flex-wrap items-center">
          
          <div className="w-full lg:w-3/12 px-4 mb-4">
            <div className="relative h-[430px] bg-white shadow-lg rounded-lg overflow-hidden group transition-transform duration-150 ease-in-out hover:scale-110">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-in-out group-hover:scale-110 rounded-lg"
                   style={{
                    "backgroundImage": "url('/assets/guitar-play.jpg')"
                    }}>
              </div>
              <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div>
              <a href="javascript:;" className="absolute bottom-0 p-6 text-left">
                <h6 className="text-xl text-white opacity-75 mb-0">All the beautiful places</h6>
                <h5 className="mt-0 mb-2 text-2xl font-bold text-white leading-tight">Research by Bang &amp; Olufsen on city sounds and music</h5>
              </a>
            </div>
          </div>

          
          <div className="w-full lg:w-3/12 px-4 mb-4">
            <div className="relative h-[430px] bg-white shadow-lg rounded-lg overflow-hidden group transition-transform duration-150 ease-in-out hover:scale-110">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-in-out group-hover:scale-110 rounded-lg"
                   style={{"backgroundImage": "url('/assets/thomas.jpg')",

                   }}>
              </div>
              <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div>
              <a href="javascript:;" className="absolute bottom-0 p-6 text-left">
                <h6 className="text-xl text-white opacity-75 mb-0">Spectrum Boats</h6>
                <h5 className="mt-0 mb-2 text-2xl font-bold text-white leading-tight">Data Virtualization and Boats Startups</h5>
              </a>
            </div>
          </div>

          
          <div className="w-full lg:w-3/12 px-4 mb-4">
            <div className="relative h-[430px] bg-white shadow-lg rounded-lg overflow-hidden group transition-transform duration-150 ease-in-out hover:scale-110">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-in-out group-hover:scale-110 rounded-lg"
                   style={{"backgroundImage": "url('/assets/ashim.jpg')",

                   }}>
              </div>
              <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div>
              <a href="javascript:;" className="absolute bottom-0 p-6 text-left">
                <h6 className="text-xl text-white opacity-75 mb-0">Flying on pandemic</h6>
                <h5 className="mt-0 mb-2 text-2xl font-bold text-white leading-tight">New Challenges when you want to fly to new areas</h5>
              </a>
            </div>
          </div>

          <div className="w-full lg:w-3/12 px-4 mb-4">
            <div className="relative h-[430px] bg-white shadow-lg rounded-lg overflow-hidden group transition-transform duration-150 ease-in-out hover:scale-110">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-in-out group-hover:scale-110 rounded-lg"
                   style={{"backgroundImage": "url('/assets/dane.jpg')"

                   }}>
              </div>
              <div className="absolute inset-0 bg-black opacity-50 rounded-lg"></div>
              <a href="javascript:;" className="absolute bottom-0 p-6 text-left">
                <h6 className="text-xl text-white opacity-75 mb-0">Work from Home</h6>
                <h5 className="mt-0 mb-2 text-2xl font-bold text-white leading-tight">How meetings and behaviour are changing</h5>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

        </>
    )
}
export default Blogpost;